<template>
    <div id="nav">
        <router-link to="/">Home</router-link> | 
        <router-link to="/discord">Community</router-link> | 
        <router-link to="/discord-bot">Bot</router-link> | 
        <router-link to="/edmc-plugin">Plugin</router-link> | 
        <router-link to="/donate">Support EDR</router-link>
    </div>
</template>

<script>
export default {
    name: 'NavBar'
}
</script>

<style>
#nav {
  padding: 30px;
  text-align: center;
}

#nav a {
  font-weight: bold;
  color: #0a8bd6;
}

#nav a.router-link-exact-active {
  color: #c2eeff;
}
</style>